import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1049314170929647';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const pixel: any = w.fbq = function () {
          pixel.callMethod ? pixel.callMethod.apply(pixel, arguments) : pixel.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = pixel;
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-black text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0" data-mp="3dkus3sf1mymh">
      <main data-id="element-1" data-mp="nvsv37yeytxj">
        <Hero data-id="element-2" data-mp="nw2c461hdqr3" />
        <TestimonialsStrip data-id="element-3" data-mp="nuhhkgf627t8" />
        <PainPoints data-id="element-4" data-mp="nvas7sh8xhgn" />
        <SolutionReveal data-id="element-5" data-mp="nxwupdpa56s0" />
        <TomosSection data-id="element-6" data-mp="su445ggvx0ep" />
        <BonusSection data-id="element-7" data-mp="stkj3qvxtvwg" />
        <PricingSection data-id="element-8" data-mp="sssrer5goibg" />
        <ExtendedTestimonials data-id="element-9" data-mp="36hwf6uoms18" />
        <Guarantee data-id="element-10" data-mp="35ox2qy1z4t4" />
        <FAQ data-id="element-11" data-mp="356r32ll9c80" />
        <FinalCTA data-id="element-12" data-mp="34nb3rfi0xwm" />
      </main>
      <Footer data-id="element-13" data-mp="3uct2jhejuizf" />
    </div>;
}